export const APP_NAME = 'Ignite Ops';
export const APP_VERSION = '1.0.0';

export const ROUTES = {
  DASHBOARD: '/',
  USERS: '/users',
  ROLES: '/roles',
} as const;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE: 0,
  DEFAULT_ROWS_PER_PAGE: 10,
  ROWS_PER_PAGE_OPTIONS: [5, 10, 25, 50],
} as const;

export const TIME_RANGES = {
  SEVEN_DAYS: 7,
  THIRTY_DAYS: 30,
} as const;

export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
} as const;


